import { AxiosError, AxiosResponse } from 'axios';
import { IMap } from './Interfaces';

export type SuccessfulResponse<Type, Status = number> = {
  success: true;
  response: AxiosResponse<Type>;
  status: Status;
};
export type ErrorResponse<Type, Status = number> = { success: false; response: AxiosError<Type>; status: Status };
export type ValidationErrorResponseData = {
  message: string;
  errors: IMap<string[], string>;
  rules: IMap<IMap<string[], string>, string>;
};
export type ValidationErrorResponse = ErrorResponse<
  ValidationErrorResponseData,
  ReservedHttpResponseCodes.ValidationError
>;
export type RenderableErrorResponse<P = Record<string, any>> = AxiosError<{
  title: string;
  description: string;
  error_code: string;
  payload?: P;
}>;
export type Response<Type, Status = number> = SuccessfulResponse<Type, Status> | ErrorResponse<Type, Status>;

export type DataWrappedResponse<Type, Status = number> = Response<DataWrapper<Type>, Status>;

export type DataWrapper<Type> = { data: Type };

/**
 * How a consumer request tells the backend which franchise it is for. `hostname` is the deployed
 * case (the backend resolves `{slug}.{root}` against its shop-domain registry, or a custom FQDN);
 * `franchise_slug` exists only for localhost / e2e builds, which have no subdomain to send.
 */
export type FranchiseResolverParams = { hostname: string } | { franchise_slug: string };

export enum ReservedHttpResponseCodes {
  PaymentConfirmationRequired = 402,
  ValidationError = 422,
  ErrorResponseModal = 412,
  ErrorResponseAlertWindow = 417,
  TooManyRequests = 429,
}

export type FeedbackLabelTypes = 'Success' | 'Error' | 'Info' | 'Warning' | 'Notice';
